

























































































































































































































































































































import {
  faCaretDown,
  faDesktop,
  faEye,
  faMobile,
  faUsers
} from '@fortawesome/free-solid-svg-icons'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      icons: {
        eye: faEye,
        people: faUsers,
        desktop: faDesktop,
        caretDown: faCaretDown,
        mobile: faMobile
      },
      pageviews: '250.000.000',
      uniqueUsers: '3.500.000'
    }
  },
  computed: {
    desktopList(): Array<string> {
      const gallery = Array(13).fill(this.$i18n.t('classified'))
      gallery[5] = this.$i18n.t('ad placement {size}', { size: '728x90' })
      return gallery
    },
    desktopGallery(): Array<string> {
      const gallery = Array(20).fill(this.$i18n.t('classified'))
      gallery[5] = this.$i18n.t('ad placement {size}', { size: '250x250' })
      return gallery
    },
    classifiedCategories(): Array<string> {
      return this.$i18n
        .t(
          'autos, motorcycles, parts & accessories, other classifieds - xymashop, real estate - plot.gr, boats - yachts, commercial - vans & trucks, motorhomes & caravans, hobbies, deals'
        )
        .split(',')
        .map(s => {
          return this.capitalize(s.trim())
        })
    },
    audience(): Array<object> {
      return [
        { key: '25-44', value: 42 },
        { key: this.$i18n.t('men'), value: 60 },
        { key: this.$i18n.t('women'), value: 40 },
        { key: this.$i18n.t('mobile phones'), value: 72 }
      ]
    },
    imgSearchUrl(): string {
      return require(`~/assets/img/advertising/mobile-view-${this.$i18n.locale}.png`)
    },
    imgViewUrl(): string {
      return require(`~/assets/img/advertising/mobile-search-${this.$i18n.locale}.png`)
    },
    navButtons(): Array<string> {
      const i18n = this.$i18n
      return [
        i18n.t('search'),
        i18n.t('offer'),
        i18n.t('dealers'),
        i18n.t('information')
      ]
    },
    advertisingText(): string {
      const country = {
        el: 'Ελλάδα',
        en: 'Greece'
      }
      return this.$i18n.t(
        '{site} is the largest classifeds platform in {country}. a clear leader in the field of vehicles(auto, moto, tractors, boats, etc.) but also offering a wide range of different sections of classifeds in various categories(technology products, home equipment, antigues, jobs, real estate etc.)',
        {
          site: 'Car.gr',
          country: country[this.$i18n.locale]
        }
      )
    }
  },
  methods: {
    capitalize(str: string): string {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  }
})
